import { EFieldType, TCardInputError } from '@libs/types';
import { TErrorCardInputResult } from './types';

const calcDiff = (start: number, end: number) => {
    const step = 10;
    let res = '';
    try {
        for (let i = start + step; i < end; i += step) {
            const year = i.toString().charAt(2);
            res += ` ${year} |`;
        }
        return res;
    } catch (e) {
        console.warn(e, 'Error calc diff');
        return res;
    }
};
export const calcExpDateRegex = (expiryYears = 20) => {
    try {
        const currYear = new Date().getFullYear();
        const expYear = currYear + expiryYears;
        const diffYears = calcDiff(currYear, expYear);
        const [, , currYearThreePos = '', currYearFourPos = ''] = currYear?.toString()?.split('') ?? [];
        const [, , expYearThreePos = '', expYearFourPos = ''] = expYear?.toString()?.split('') ?? [];
        return `^(0[1-9]|1[0-2])/(([${+currYearThreePos}][${+currYearFourPos}-9])|([${diffYears}][0-9])|([${+expYearThreePos}][0-${+expYearFourPos}]))$`;
    } catch (e) {
        console.warn(e, 'Error calc date regex');
        return '^(0[1-9]|1[0-2])/[0-9][0-9]';
    }
};

export const calcValid = (value: string, regex: RegExp, limit: number): boolean => {
    try {
        const clearValue = value?.replace(regex, '') ?? '';
        return clearValue.length >= limit;
    } catch (e) {
        console.warn(e, 'Error calcValid');
        return false;
    }
};

export const getErrors = (errors: TCardInputError[]) => {
    const result = {
        cardNumber: undefined,
        expDate: undefined,
        card: undefined,
    };
    if (errors.length > 0) {
        errors.reduce((acc: TErrorCardInputResult, error: TCardInputError) => {
            if (error.field === EFieldType.CARD_NUMBER) {
                acc.cardNumber = { ...error };
            } else if (error.field === EFieldType.EXP_DATE) {
                acc.expDate = { ...error };
            } else if (error.field === EFieldType.CARD) {
                acc.card = { ...error };
            }
            return acc;
        }, result);
    }
    return result;
};
